<div class="d-flex flex-column gap-3">
  <div class="btn-group" role="group">
    @for (status of statuses; track status) {
      <button
        type="button"
        class="btn"
        [class.btn-primary]="selectedStatus() === status"
        [class.btn-outline-primary]="selectedStatus() !== status"
        (click)="selectStatus(status)"
      >
        {{ 'help-curation.status.' + status | lowercase | translate }}
      </button>
    }
  </div>

  @if (hasError()) {
    <div class="alert alert-danger mb-0">{{ 'help-curation.error' | translate }}</div>
  }

  @if (isLoading()) {
    <p class="text-secondary mb-0">{{ 'help-curation.loading' | translate }}</p>
  } @else if (!items().length) {
    <p class="text-secondary mb-0">{{ 'help-curation.empty' | translate }}</p>
  } @else {
    @for (item of items(); track key(item)) {
      <div class="card">
        <div class="card-body d-flex flex-column gap-2">
          <div class="d-flex justify-content-between align-items-start gap-2">
            <strong>{{ item.question }}</strong>
            <span class="badge text-bg-light">{{ item.locale }}</span>
          </div>

          <div class="d-flex flex-wrap gap-2 align-items-center">
            @if (item.feedbackHelpful === true) {
              <span class="badge text-bg-success">{{ 'help-curation.feedback-helpful' | translate }}</span>
            } @else if (item.feedbackHelpful === false) {
              <span class="badge text-bg-danger">{{ 'help-curation.feedback-not-helpful' | translate }}</span>
            }
            @if (item.feedbackComment) {
              <span class="text-secondary small">"{{ item.feedbackComment }}"</span>
            }
          </div>

          @if (selectedStatus() === eHelpCurationStatus.Pending) {
            <label class="form-label mb-1 small text-secondary">
              {{ 'help-curation.answer' | translate }}
              <textarea
                class="form-control"
                rows="6"
                [ngModel]="drafts()[key(item)]"
                (ngModelChange)="updateDraft(item, $event)"
              ></textarea>
            </label>

            <input
              type="text"
              class="form-control"
              [placeholder]="'help-curation.reason-placeholder' | translate"
              [ngModel]="reasons()[key(item)]"
              (ngModelChange)="updateReason(item, $event)"
            />
            <div class="d-flex gap-2">
              <button
                type="button"
                class="btn btn-success"
                [disabled]="busyKey() === key(item)"
                (click)="promote(item)"
              >
                {{ 'help-curation.promote' | translate }}
              </button>
              <button
                type="button"
                class="btn btn-outline-danger"
                [disabled]="busyKey() === key(item)"
                (click)="reject(item)"
              >
                {{ 'help-curation.reject' | translate }}
              </button>
            </div>
          } @else {
            <p class="mb-0" style="white-space: pre-wrap">{{ item.answer }}</p>
            @if (selectedStatus() === eHelpCurationStatus.Rejected && item.rejectedReason) {
              <p class="text-danger small mb-0">{{ item.rejectedReason }}</p>
            }
          }
        </div>
      </div>
    }
  }
</div>
